import React, { useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";

const InputAreaDate = ({
  register,
  name,
  label,
  value,
  onChange,
  min,
  max,
  readOnly,
}) => {
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);

  const CustomDatePickerInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="relative">
      <input
        value={value}
        ref={(node) => {
          inputRef.current = node;
          if (ref) ref.current = node;
        }}
        readOnly
        onClick={(e) => {
          if (!readOnly) {
            setOpen(true);
            onClick?.(e);
          }
        }}
        onFocus={() => {
          if (!readOnly) {
            setOpen(true);
          }
        }}
        className="px-3 py-1 dark:text-gray-300 leading-5 rounded-md focus:border-gray-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 border h-10 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-transparent border-transparent focus:bg-white pr-10"
        autoComplete="off"
        aria-label={label || "Select date"}
      />
      {!value && (
        <FaCalendarAlt
          className="absolute top-0 right-0 mt-3 mr-3 text-gray-400 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            if (!readOnly) {
              setOpen(true);
              onClick?.(e);
            }
          }}
          aria-label="Open calendar"
        />
      )}
    </div>
  ));

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
        >
        </label>
      )}
    <DatePicker
  id={name}
  isClearable
  selected={value ? new Date(value) : null}
  onChange={(date) => {
    onChange(date);
    setTimeout(() => {
      setOpen(false);
      inputRef.current?.blur();
    }, 100);
  }}
  onSelect={() => setOpen(false)}
  onClickOutside={() => setOpen(false)}
  dateFormat="dd/MM/yyyy"
  name={name}
  disabled={readOnly}
  minDate={min}
  maxDate={max}
  onCalendarOpen={() => setOpen(true)}
  onCalendarClose={() => {
    setOpen(false);
    inputRef.current?.blur();
  }}
  customInput={<CustomDatePickerInput />}
  shouldCloseOnSelect={true}
  open={open}
  popperPlacement="bottom-start"
  popperModifiers={[
    { name: "flip", enabled: false },
    { name: "preventOverflow", options: { boundary: "clippingParents" } },
  ]}
  popperProps={{ strategy: "fixed" }}
/>

    </div>
  );
};

export default InputAreaDate;
